<div class="login-page">
  <!-- Animated Background Shapes -->
  <div class="background-shapes">
    <div class="shape shape-1"></div>
    <div class="shape shape-2"></div>
    <div class="shape shape-3"></div>
  </div>

  <div class="login-container">
    <!-- LEFT SIDE: Client Branding -->
    <div class="left-panel">
      <div class="client-branding">
        <!-- Client Logo -->
        <div class="client-logo-container" [class.has-logo]="logoUrl">
          <img *ngIf="logoUrl" [src]="logoUrl" alt="{{ tenantName }} Logo" class="client-logo" />
          <div *ngIf="!logoUrl" class="client-logo-placeholder">
            <span>{{ tenantName.charAt(0) }}</span>
          </div>
        </div>
        
        <!-- Client Name -->
        <h1 class="client-name">{{ tenantName }}</h1>
        
        <!-- Client Tagline -->
        <p class="client-tagline">{{ tagLine }}</p>
      </div>
    </div>

    <!-- RIGHT SIDE: Sign In Form -->
    <div class="right-panel">
      <div class="form-container">
        <!-- NuvertOS Logo at Top -->
        <div class="nuvertos-branding">
          <img src="NuvertOS.png" alt="NuvertOS" class="nuvertos-logo" />
        </div>

        <!-- Login Card -->
        <div class="login-card">
          <form [formGroup]="loginForm" (ngSubmit)="onLogin()">
            <h2 class="form-title">Sign In</h2>
            <p class="form-subtitle">Enter your credentials to access your account</p>

            <!-- Email Field -->
            <div class="form-group">
              <label for="email" class="form-label">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect width="20" height="16" x="2" y="4" rx="2"/>
                  <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
                </svg>
                Email
              </label>
              <input 
                pInputText
                id="email"
                type="email"
                formControlName="email"
                class="form-input"
                placeholder="Enter your email"
              />
              <span *ngIf="email?.invalid && (email?.dirty || email?.touched)" class="error-message">
                <span *ngIf="email?.errors?.['required']">Email is required.</span>
                <span *ngIf="email?.errors?.['email']">Please enter a valid email address.</span>
              </span>
            </div>

            <!-- Password Field -->
            <div class="form-group">
              <label for="password" class="form-label">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect width="18" height="11" x="3" y="11" rx="2" ry="2"/>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
                Password
              </label>
              <p-password
                formControlName="password"
                [feedback]="false"
                [toggleMask]="true"
                inputClass="form-input"
                id="password"
                placeholder="Enter your password"
                styleClass="password-wrapper"
              ></p-password>
              <span *ngIf="password?.invalid && (password?.dirty || password?.touched)" class="error-message">
                <span *ngIf="password?.errors?.['required']">Password is required.</span>
                <span *ngIf="password?.errors?.['minlength']">Password must be at least 6 characters.</span>
              </span>
            </div>

            <!-- Submit Button -->
            <button 
              pButton
              type="submit"
              class="submit-btn"
              [disabled]="loginForm.invalid || loading"
            >
              <span *ngIf="!loading">Sign In</span>
              <span *ngIf="loading" class="loading-state">
                <svg class="spinner" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle class="spinner-track" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="spinner-path" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Signing in...
              </span>
            </button>
          </form>
        </div>

        <!-- Footer -->
        <p class="footer-text">
          Powered by <strong>NuvertOS</strong>
        </p>
      </div>
    </div>
  </div>
</div>
